import {Component, Host, h, Prop, EventEmitter, Event, Watch} from '@stencil/core';
import {Logger} from "../../utils/logger";
import {IRequestField} from "../../interfaces/configuration";

@Component({
  tag: 'securecall-request-string',
  styleUrl: 'securecall-request-string.css',
  shadow: true,
})
export class SecurecallRequestString {
  @Prop() fieldName: string;
  @Prop({ mutable: true }) config: IRequestField;

  @Event() isValidEvent: EventEmitter<{ field: string; valid: boolean, value: string }>;

  private readonly log = Logger('SecurecallRequestString')

  public get value(): string {
    return this.config.value;
  }
  public set value(value: string) {
    if (this.config.value !== value) {
      this.config.value = value;
      this.validateChange();
    }
  }

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    this.log.debug(this.fieldName + ": handleConfigChange: config", newConfig, oldConfig);
    if(oldConfig.value !== newConfig.value) {
      this.value = newConfig.value;
      this.validateChange();
    } else if(oldConfig.valid !== newConfig.valid) {
      this.validateChange();
    }
  }

  componentWillLoad() {
    this.log.debug(this.fieldName + ": componentWillLoad: config", this.config);
    this.validateChange();
  }

  handleChange(ev) {
    this.log.debug(this.fieldName + ": handleChange: string change:", ev.target.value);
    this.value = ev.target.value;
  }

  validateChange() {
    const input = this.value;
    this.log.debug(this.fieldName + ": validateChange: string:", input);
    if(this.config.optional && (!input || input.trim() === ''))
      return this.isValidEvent.emit({ field: this.fieldName, valid: true, value: '' });

    const minLength = this.config.min || 1;
    const maxLength = this.config.max;

    const isValid = input?.length >= minLength && (!maxLength || input.length <= maxLength);

    this.isValidEvent.emit({ field: this.fieldName, valid: isValid, value: input });
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label">
            {this.config.label}:
          </label>
          <input
            type="text"
            class="custom-input"
            id={this.fieldName}
            placeholder={this.config.placeholder || this.config.label}
            value={this.value}
            disabled={this.config.readOnly}
            onInput={(ev) => this.handleChange(ev)}
          />
          <div class="validity none"></div>
        </div>
      </Host>
    );
  }
}
